import { UserService } from '@aifs-shared/user/user.service';
import { Component, OnInit, Output, EventEmitter, inject, computed } from '@angular/core';

@Component({
    selector: 'app-account-menu',
    templateUrl: './account-menu.component.html',
    styleUrls: ['./account-menu.component.scss']
})
export class AccountMenuComponent implements OnInit {

    @Output() menuItemClicked = new EventEmitter<string>();
    @Output() signOutClicked = new EventEmitter();

    private userService = inject(UserService);

    isApplicant = computed(() => this.userService.isApplicant());
    hasActiveApplication = computed(() => this.userService.hasApplication());
    activeApplicationId = computed(() => this.userService.activeApplicationId());

    constructor() { }

    ngOnInit() {
    }

    navigateTo(url: string): void {
        this.menuItemClicked.emit(url);
    }

    signOut(): void {
        this.signOutClicked.emit();
    }
}
